import { render, staticRenderFns } from "./PhotoVideo.vue?vue&type=template&id=fa9568c4&"
import script from "./PhotoVideo.vue?vue&type=script&lang=js&"
export * from "./PhotoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports